import { render, staticRenderFns } from "./Packs.vue?vue&type=template&id=237b695a&scoped=true&"
import script from "./Packs.vue?vue&type=script&lang=js&"
export * from "./Packs.vue?vue&type=script&lang=js&"
import style0 from "./Packs.vue?vue&type=style&index=0&id=237b695a&lang=scss&scoped=true&"
import style1 from "./Packs.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237b695a",
  null
  
)

export default component.exports